/**
 * Public barrel export for the PositionBadge molecule (SE-5527).
 * @module components/molecules/PositionBadge
 */
export { default } from "./PositionBadgeView";
export type { PositionBadgeProps } from "./PositionBadgeView";
